import { AccountDetectionModeService } from "../../services/AccountDetectionModeService";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { store } from "../AppState";
import AccountDetectionModeResult from "@/InscriptionFlowsAdmin/models/responses/AccountDetectionModeResult";

@Module({
  namespaced: true,
  name: "accountDetectionModesModule",
  store: store,
  dynamic: true
})
export class AccountDetectionModeModule extends VuexModule {
  accountDetectionModes: AccountDetectionModeResult[] = [];
  flowADM: AccountDetectionModeResult["code"] | null = null;

  @Action
  async list() {
    const response = await AccountDetectionModeService.List();
    this.setAccountDetectionModes(response.data);
    return response.data;
  }

  @Action
  async setFlowADM(adm: AccountDetectionModeResult) {
    this._setFlowADM(adm);
  }

  @Mutation
  setAccountDetectionModes(value: AccountDetectionModeResult[]) {
    this.accountDetectionModes = value;
  }

  @Mutation
  async _setFlowADM(adm: AccountDetectionModeResult) {
    this.flowADM = adm.code;
  }
}
